import React, { Component } from 'react';
import Vas from '../../../Vas';
//import '../../../css/CustomerCreateContract.css';
import { LinkButton } from 'component-lib';

class CustomerRelationDeleteSuccess extends Component
{

  constructor(props)
  {
    super(props);
    this.state = {};
    this.CustomerId = props.match.params.CustomerId
  }
 
  render()
  {
    return (
      <div
        className={"PaymentContainer"}
      >
        <div className={"form"}>
          <table >
            <thead>
              <tr>
                <th style={{fontSize:'large',width:'450px'}} colSpan={2}>
                  {Vas.Resources.Labels["DeleteCompanyAssignmentSuccess"]}
                  <br />
                  <br />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr>
                <td style={{ fontSize:'14px', textAlign: 'right' }}>{Vas.Resources.Labels["LinkLoginPlural"]}</td>
                <td style={{ textAlign: 'left' }}>
                  <LinkButton
                  Text={Vas.Resources.Labels["PersonalDataLink"]}
                  Id={"LinkLogin"}
                  OnClick={()=>{Vas.GetView("CustomerCard", { Id :this.props.match.params.CustomerId }, true);}} /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
export default CustomerRelationDeleteSuccess;
